export default () => ({
	graphQlVariables: "",
	filter: {
		where: null
	}
})
